import React from 'react';

import Features from '@dashboard/enums/features';

import usePage from '@dashboard/hooks/usePage';

import CanUseFeature from '@dashboard/components/CanUseFeature';
import Link from '@dashboard/components/Link';

import PageEditView from '../components/PageEditView';

import EmailConfirmationForm from './PageSettings/components/EmailConfirmationForm';
import FunnelStepsForm from './PageSettings/components/FunnelStepsForm';
import PageConfirmationForm from './PageSettings/components/PageConfirmationForm';
import IntegrationsForm from './PageSettings/components/IntegrationsForm';
import { PAGE_TYPES } from '@/dashboard/enums/page-types';

const PageAfterPayment = () => {
  const { page } = usePage();

  return (
    <PageEditView
      tabs={[
        {
          path: '/confirmation',
          label: 'Confirmation',
          component: <PageConfirmationForm />,
        },
        {
          path: '/email-confirmation',
          label: 'Email confirmation',
          component: <EmailConfirmationForm />,
        },
        {
          path: '/integrations',
          label: 'Integrations',
          component: (
            <div className="">
              {page.type === PAGE_TYPES.CHECKOUT && (
                <div className="mb-4 text-gray-700">
                  Connect to your favorite apps and services. These integrations will be triggered
                  when a customer completes a purchase.{' '}
                  <Link href="/help/articles/integrations" target="_blank">
                    Learn more
                  </Link>
                </div>
              )}

              {page.type === PAGE_TYPES.EVENT && (
                <div className="mb-4 text-gray-700">
                  Connect to your favorite apps and services. These integrations will be triggered
                  when someone makes a booking.{' '}
                  <Link href="/help/articles/integrations" target="_blank">
                    Learn more
                  </Link>
                </div>
              )}

              {page.type === PAGE_TYPES.FORM && (
                <div className="mb-4 text-gray-700">
                  Connect to your favorite apps and services. These integrations will be triggered
                  when a customer submits a form.{' '}
                  <Link href="/help/articles/integrations" target="_blank">
                    Learn more
                  </Link>
                </div>
              )}

              <IntegrationsForm />
            </div>
          ),
        },

        ...(page.type === 'checkout'
          ? [
              {
                path: '/one-click-upsell',
                label: 'One-click upsell',
                component: (
                  <CanUseFeature feature={Features.ONE_CLICK_UPSELLS}>
                    <FunnelStepsForm />
                  </CanUseFeature>
                ),
                description: (
                  <>
                    Offer a one-click upsell after successful checkout.{' '}
                    <Link to="/help/one-click-upsells" target="_blank">
                      Learn more
                    </Link>
                  </>
                ),
              },
            ]
          : []),
      ]}
    />
  );
};

export default PageAfterPayment;
